import {createSlice} from "@reduxjs/toolkit";
import {clientsCategoryData} from "../../../_data/clients/clients-settings";
import moment from "moment";
import {getCurrentUser} from "../../../_helpers/commonFunctions";

const currentDate = moment().format('DD/MM/YYYY');
let date = new Date();
const currentTime = moment().format('H:mm');
const currentUser = getCurrentUser();
const cUserName = currentUser?.name;
const currentMonth = moment().format("MM");
const current = new Date();
const lastDayOfYear = (localStorage.getItem("company") && JSON.parse(localStorage.getItem("company"))?.year !== moment().format("YYYY")) ? moment().year(JSON.parse(localStorage.getItem("company"))?.year).endOf('year').format('DD-MM-YYYY') : null;
const newInstallationInitialValue = {
    no: '',
    type: '',
    address: '',
    DOY: '',
    city: '',
    id: '',
    vatCategory: '',
    vatReason: '',
    customVat: ''
}

export const newClientInitialValue = {
    category: "",
    categoryName: "",
    systemCode: "",
    manualCode: "",
    name: "",
    smallName: "",
    vatCategory: "Normal VAT",
    vatReason: "",
    customVat: "",
    vatNumber: "",
    DOY: "",
    activity: "",
    amka: "",
    country: "GR",
    address: "",
    city: "",
    postalCode: "",
    email: "",
    gemhNo: "",
    webpage: "",
    phone: "",
    contactPoints: [{
        no: 1,
        id: 1,
        name: "",
        mobile: "",
        landline: "",
        otherPhone: "",
        email: "",
        contactNotes: ""
    }],
    bankInfo: [],
    clientNotes: "",
    informationNotes: "",
    notesNotes: "",
    installations: [newInstallationInitialValue],
    communicationHistory: [],
    information: [],
    notes: [],
    emronPasswords: [],
    stockholders: [],
    emronPayments: [],
    accounting: "",
    bypassAccounting: "",
    clientsInfo: [],
    isActive: 'active',
    balance: 0,
    capital: 0,
    peppolPartyIdentification: [],
}

export const clientSettingsInitialValues = {
    categories: clientsCategoryData,
    googleCalendarApi: "",
    clientCommunicationHistory: "",
    clientsInfo: [],
    type: "clientsSettings",
    isActive: "active"
}

export const clientMovementsInitialValues = {
    documentType: '',
    documentTypeName: '',
    document_file: '',
    number: '',
    date: date,
    reason: '',
    sum: 0,
    clients: [],
    notes: '',
}

const priceListInitialValues = {
    name: "",
    price: "",
    clientList: [],
    notes: "",
}

const newContactPointInitialValue = {
    no: 1,
    id: 1,
    name: "",
    mobile: "",
    landline: "",
    otherPhone: "",
    email: "",
    // acceptsNotifications: false,
    contactNotes: ""
}

const newBankInfoInitialValue = {
    bankFriendlyName: "",
    bankInstitute: "",
    iban: ""
}

const newInformationInitialValue = {
    no: '',
    description: '',
    details: '',
    date: currentDate.toString(),
    time: currentTime.toString(),
    lastEditedBy: cUserName,
}

const clientMovementsNewClientInitialValue = {
    no: 1,
    clientId: "",
    name: "",
    code: "",
    measurementUnit: "",
    quantity: 0,
}

const newCommunicationHistoryInitialValue = {
    no: 1,
    id: 1,
    date: new Date(),
    time: currentTime.toString(),
    subject: "",
    details: "",
    followUpDate: "",
    createCalenderEvent: false,
    done: false
}

export const newClientPaymentInitialValue = {
    documentType: "",
    documentTypeName: "",
    installation: "",
    preNumber: "",
    number: "",
    numberingMode: "manual",
    date: null,
    paymentType: "",
    paymentTypeName: "",
    client: "",
    clientName: "",
    vatNumber: "",
    address: "",
    country: "",
    phone: "",
    email: "",
    reason: "",
    paymentNotes: "",
    amount: "0",
    posDetails: [{
        no: 1,
        id: 1,
        name: "",
        registrationNumber: "",
        amount: "0",
        notes: ""
    }],
    bankDetails: [{
        no: 1,
        id: 1,
        name: "",
        accountNumber: "",
        amount: "0",
        notes: ""
    }],
    chequeDetails: [{
        no: 1,
        id: 1,
        startDate: "",
        endDate: "",
        amount: "0",
        notes: ""
    }],
    returnPayment: "",
    returnPaymentLabel: "",
    tipAmount: 0, // Not saved the database
}

const newClientEmronPasswordInitialValue = {
    no: 1,
    id: 1,
    type: "",
    username: "",
    password: "",
    notes: ""
}
const newClientEmronStockholderInitialValue = {
    no: 1,
    id: 1,
    name: "",
    surname: "",
    vat: "",
    position: "",
    percentage: "",
    stockValue: 0,
    dateFrom: "",
    dateTo: ""
}

const newEmronPaymentInitialValue = {
    no: 1,
    id: 1,
    installationType: "",
    installation: "",
    month: "",
    monthTo: "",
    clientName: "",
    amount: 0,
    notes: "",
    difficulty: "",
    difficultyNotes: "",

}

const newCategoryInitialValue = {
    _id: 1,
    category: '',
    mask: 'CCM-0001',
    maskCode: '',
    maskCodePrefix: 'CCM',
    maskCodeCounter: 1,
    isActive: 'active',
    type: 'client',
}

const initClientBalanceReportRequestData = {
    showZeroBalance: "inactive",
    showInActive: "inactive",
    includeSettlements: "inactive",
    clientName: "",
    date_to: lastDayOfYear ? lastDayOfYear : moment().format("DD/MM/YYYY"),
    page: 1,
}

const initClientBalanceReportResponseData = {
    totalPages: 0,
    data: [],
    totalBalance: 0,
    includeSettlements: "inactive",
}

const initClientMovementsReportRequestData = {
    page: 1,
    date_from: "",
    date_to: "",
    clientIds: [],
    client_zero: "inactive",
    client_inactive: "inactive",
    showNotes: "inactive",
}

const initClientMovementsReportResponseData = {
    totalPages: 0,
    pageData: [],
    pageClientData: {},
}

const initClientIsozygioReportRequestData = {
    firstLoad: true, // For date setup
    zeroBalanceClients: false,
    page: 1,
    date_from: "",
    date_to: "",
    clientId: "",
    clientName: "",
}

const initClientIsozygioReportResponseData = {
    totalPages: 0,
    data: [],
}

const initClientIsozygioReportTotals = [];

const initialState = {
    clientSettingsInitialValues: clientSettingsInitialValues,
    newClientsSettings: clientSettingsInitialValues,
    clientsSettings: clientSettingsInitialValues,
    clientsListData: [],
    clientsPayment: [],
    clientPayments: [],
    newClientPaymentInitialValue: newClientPaymentInitialValue,
    newClientPayment: newClientPaymentInitialValue,
    autoClientPaymentData: null,
    editClientPayment: newClientPaymentInitialValue,
    loading: false,
    hasErrors: false,
    clients: [],
    installations: [],
    newClientInitialValue: newClientInitialValue,
    newClient: newClientInitialValue,
    newClientModal: newClientInitialValue,
    autoNewClientFields: null,
    editClient: {},
    newContactPointInitialValue: newContactPointInitialValue,
    newContactPoint: newContactPointInitialValue,
    editContactPoint: newContactPointInitialValue,
    newBankInfoInitialValue: newBankInfoInitialValue,
    editBankInfo: newBankInfoInitialValue,
    newBankInfo: newBankInfoInitialValue,
    newInstallationInitialValue: newInstallationInitialValue,
    newInstallation: newInstallationInitialValue,
    newInformationInitialValue: newInformationInitialValue,
    newInformation: newInformationInitialValue,
    newNotesInitialValue: newInformationInitialValue,
    newNotes: {},
    newCommunicationHistoryInitialValue: newCommunicationHistoryInitialValue,
    newCommunicationHistory: newCommunicationHistoryInitialValue,
    searchClients: [],
    totalItemsCS: 0,
    perPageCS: 0,
    searchClientMovements: [],
    totalItemsCMS: 0,
    perPageCMS: 0,
    searchClientPayments: [],
    perPageCPS: 0,
    totalItemsCPS: 0,
    searchClientsMovementsReport: [],
    searchCommunicationHistory: [],
    selectedClient: {},
    selectedClientTo: {},
    selectedClientFrom: {},
    selectedStartDateFrom: null,
    clientReportBalanceData: [],
    clientReportMovementsData: [],
    clientReportMovementsClientList: [],
    clientMovementsSearchByBalance: {},
    selectedDateBalance: current,
    selectedZero: false,
    selectedInactive: false,
    selectedZeroBalance: false,
    selectedInactiveBalance: false,
    selectedStartDateTo: null,
    selectedFilterBy: currentMonth,
    selectedBalanceClientFrom: {},
    selectedBalanceClientTo: {},
    selectedSalesClientFrom: {},
    selectedSalesClientTo: {},
    selectedEmronPaymentsFilters: null,
    selectedEmronPaymentsMonth: new Date(),
    selectedEmronPaymentsClientFrom: {},
    selectedEmronPaymentsClientTo: {},
    selectedEmronPaymentsInstallations: "active",
    selectedEmronPaymentsZero: "inactive",
    selectedMyDataReportClient: {},
    selectedSalesBalanceClientFrom: {},
    selectedSalesBalanceClientTo: {},
    selectedSalesGraphicClientFrom: {},
    selectedSalesGraphicClientTo: {},
    clientTemplates: [],
    selectedClientTemplate: {},
    clientMovements: [],
    clientMovementsTemplates: [],
    selectedClientMovementsTemplate: {},
    clientMovementsNewClientInitialValue: clientMovementsNewClientInitialValue,
    clientMovementsNewClient: clientMovementsNewClientInitialValue,
    clientMovementsEditClientInitialValue: clientMovementsNewClientInitialValue,
    clientMovementsEditClient: clientMovementsNewClientInitialValue,
    clientPriceListTemplates: [],
    selectedClientPriceListTemplate: {},
    submitting: false,
    selectedCategoryData: {},
    clientMovementsInitialValues: clientMovementsInitialValues,
    clientMovementsClients: [],
    newClientMovements: clientMovementsInitialValues,
    editClientMovements: {},
    priceListInitialValues: priceListInitialValues,
    priceListClients: [],
    newPriceList: priceListInitialValues,
    newQuickClient: newClientInitialValue,
    clientEmron: {
        password: [],
        capital: '',
        stockholders: [],
        clientId: '',
    },
    newClientEmronPasswordInitialValue: newClientEmronPasswordInitialValue,
    newClientEmronPassword: newClientEmronPasswordInitialValue,
    editClientEmronPassword: newClientEmronPasswordInitialValue,
    newEmronPayment: newEmronPaymentInitialValue,
    newClientEmronStockholderInitialValue: newClientEmronStockholderInitialValue,
    newClientEmronStockholder: newClientEmronStockholderInitialValue,
    editClientEmronStockholder: newClientEmronStockholderInitialValue,
    clientPaymentsTemplates: [],
    selectedClientPaymentsTemplate: {},
    newCategoryInitialValue: newCategoryInitialValue,
    newCategory: newCategoryInitialValue,
    categories: clientsCategoryData,
    aiCommunicationHistory: {},

    reportPrimerPaymentsRequestData: {
        page: 1,
        totalPages: 0,
        clientName: "",
        subscriptionNames: [],
        paymentDateFrom: "",
        paymentDateTo: "",
        startDateFrom: "",
        startDateTo: "",
        voucher: "both",
        status: "active",
        tid: "",
    },
    reportPrimerPaymentsResponseData: {
        totalPages: 0,
        data: [],
        totalNetValue: 0,
        totalFeeValue: 0,
    },

    reportPrimerPaymentsAdminRequestData: {
        page: 1,
        totalPages: 0,
        clientName: "",
        seller: "",
        firstLoad: true,
        subscriptionNames: [],
        dateFrom: moment().startOf("month").format("DD/MM/YYYY"),
        dateTo: moment().endOf("month").format("DD/MM/YYYY"),
        status: [],
    },
    reportPrimerPaymentsAdminResponseData: {
        totalPages: 0,
        data: [],
        totalNetValue: 0,
    },

    // Client Balance Report Data
    clientBalanceReportRequestData: {},
    clientBalanceReportResponseData: {},

    // Client Movements Report
    clientMovementsReportRequestData: {},
    clientMovementsReportResponseData: {},

    // Client Isozygio Report
    clientIsozygioReportRequestData: {},
    clientIsozygioReportResponseData: {},
    clientIsozygioReportTotals: {},

    // Client Provider Contracts Report
    clientContractsReportRequestData: {
        page: 1,
        clientId: "",
        clientName: "",
        clientEmail: "",
        clientPhone: "",
        statuses: [],
        subscriptionNames: [],
        sendStatementStatus: [],
    },
    clientContractsReportResponseData: {
        data: [],
        totalPages: 0,
        totals: null,
    },

    // Emron Monthly Report
    emronMonthlyReportRequestData: {
        page: 1,
        month: moment().toDate(),
        clientName: "",
        year: "",
        cardPayments: "both", // "both", "card", "no_card"
        cardPaymentsStatus: "", // paid, pending, failed
        groupInstallations: "inactive",
        groupClients: "inactive",
        showZero: "inactive",
    },
    emronMonthlyReportResponseData: {
        data: [],
        months: [],
        totals: {},
        totalPages: 0,
    },

    // Emron Settlements Report
    emronSettlementsReportRequestData: {
        page: 1,
        date_from: "",
        date_to: "",
        clientId: "",
        clientName: "",
        showOverdue: false,
        doseAnalysis: false,
        showFullyPaid: false,
    },
    emronSettlementsReportResponseData: {
        data: [],
        doseAnalysis: false,
        totalPaidAmount: 0,
        totalSettledAmount: 0,
        totalRemainingAmount: 0,
        totalPages: 0,
    },
    selectedClientCategory: {},

    // Primer POS Report
    primerPosRequestData: {
        page: 1,
        date_from: "",
        date_to: "",
        subscription_date_from: "",
        subscription_date_to: "",
        shipping_date_from: "",
        shipping_date_to: "",
        client: "",
        serialNumber: "",
        acsVoucher: "",
        simId: "",
        status: "",
        contractStatus: "",
        subscriptions: "",
        subscriptionStatus: "",
        configurationStatus: "",
        warehousePosition: "",
        subscriptionId: "",
        remote: false
    },
    primerPosResponseData: {
        data: [],
        totals: [],
        totalPages: 0
    },
    selectedPrimerPos: null,
    primerPosPrintVoucherPosition: 1,

    // Primer POS List
    primerPosListRequestData: {
        page: 1,
        date_from: moment().startOf("month").format("DD/MM/YYYY"),
        date_to: moment().endOf("month").format("DD/MM/YYYY"),
        listId: "",
        status: "",
        client: "",
        serialNumber: ""
    },
    primerPosListResponseData: {
        data: [],
        totalPages: 0
    },
    selectedPrimerPosList: null,
    insertNewPrimerPosListData: {
        show: false,
        shippingDate: new Date(),
        savedVouchers: [],
        voucherInput: ""
    }
}

// Client Slice
export const ClientsSlice = createSlice({
    name: "client",
    initialState,
    reducers: {
        setClientNewCategory: (state, {payload}) => {
            state.newCategory = payload;
        },

        resetClientNewCategory: (state) => {
            state.newCategory = state.newCategoryInitialValue;
        },

        setClients: (state, {payload}) => {
            state.clients = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setNewClient: (state, {payload}) => {
            state.newClient = payload;
        },

        setAutoNewClientFields: (state, {payload}) => {
            state.autoNewClientFields = payload;
        },

        resetNewClient: (state) => {
            state.newClient = state.newClientInitialValue;
        },
        setNewClientModal: (state, {payload}) => {
            state.newClientModal = payload;
        },

        resetNewClientModal: (state) => {
            state.newClientModal = state.newClientInitialValue;
        },

        setEditClient: (state, action) => {
            const tabKey = action?.meta?.tabKey;
            if (!tabKey) { // Update by open _id
                for (const key in state.editClient) {
                    if (state.editClient[key]._id === action.payload._id) {
                        state.editClient[key] = action.payload;
                        break;
                    }
                }
            } else {
                state.editClient[tabKey] = action.payload;
            }
        },

        setNewContactPoint: (state, {payload}) => {
            state.newContactPoint = payload;
        },

        setEditContactPoint: (state, {payload}) => {
            state.editContactPoint = payload;
        },

        setNewBankInfo: (state, {payload}) => {
            state.newBankInfo = payload;
        },

        setEditBankInfo: (state, {payload}) => {
            state.editBankInfo = payload;
        },

        resetNewBankInfo: (state) => {
            state.newBankInfo = state.newBankInfoInitialValue;
        },

        resetEditBankInfo: (state) => {
            state.editBankInfo = state.newBankInfoInitialValue;
        },

        setNewInstallations: (state, {payload}) => {
            state.newInstallation = payload;
        },

        resetNewInstallations: (state) => {
            state.newInstallation = state.newInstallationInitialValue;
        },

        setNewInformation: (state, {payload}) => {
            state.newInformation = payload;
        },

        setNewNotes: (state, {payload}) => {
            state.newNotes = payload;
        },
        resetNewNotes: (state) => {
            state.newNotes = {};
        },
        setNewCommunicationHistory: (state, {payload}) => {
            state.newCommunicationHistory = payload;
        },

        resetNewCommunicationHistory: (state) => {
            state.newCommunicationHistory = state.newCommunicationHistoryInitialValue;
        },

        setSearchClients: (state, {payload}) => {
            state.searchClients = payload;
        },

        setSearchClientMovements: (state, {payload}) => {
            state.searchClientMovements = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setSelectedFilterBy: (state, {payload}) => {
            state.selectedFilterBy = payload;
        },
        setSelectedStartDateFrom: (state, {payload}) => {
            state.selectedStartDateFrom = payload;
        },
        setClientMovementsSearchByBalance: (state, {payload}) => {
            state.clientMovementsSearchByBalance = payload;
        },
        setSelectedStartDateTo: (state, {payload}) => {
            state.selectedStartDateTo = payload;
        },
        setSelectedDateBalance: (state, {payload}) => {
            state.selectedDateBalance = payload;
        },
        setSelectedZero: (state, {payload}) => {
            state.selectedZero = payload;
        },
        setSelectedInactive: (state, {payload}) => {
            state.selectedInactive = payload;
        },
        setSelectedZeroBalance: (state, {payload}) => {
            state.selectedZeroBalance = payload;
        },
        setSelectedInactiveBalance: (state, {payload}) => {
            state.selectedInactiveBalance = payload;
        },
        setSelectedEmronPaymentsFilters: (state, {payload}) => {
            state.selectedEmronPaymentsFilters = payload;
        },

        setClientTemplates: (state, {payload}) => {
            state.clientTemplates = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setSelectedClientTemplate: (state, {payload}) => {
            state.selectedClientTemplate = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setClientMovementsTemplates: (state, {payload}) => {
            state.clientMovementsTemplates = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setNewClientMovements: (state, {payload}) => {
            state.newClientMovements = payload;
        },
        resetNewClientMovements: (state) => {
            state.newClientMovements = state.clientMovementsInitialValues;
        },

        setEditClientMovements: (state, {payload}) => {
            state.editClientMovements = payload;
        },

        setSelectedClientMovementsTemplate: (state, {payload}) => {
            state.selectedClientMovementsTemplate = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setNewPriceList: (state, {payload}) => {
            state.newPriceList = payload;
        },

        setClientsSettings: (state, {payload}) => {
            state.clientsSettings = payload;
            state.categories = payload.categories;
        },

        setClientsPayment: (state, {payload}) => {
            state.clientsPayment = payload;
        },

        setNewClientPayment: (state, {payload}) => {
            state.newClientPayment = payload;
        },

        resetNewClientPayment: (state) => {
            state.newClientPayment = state.newClientPaymentInitialValue;
        },

        setAutoClientPaymentData: (state, {payload}) => {
            state.autoClientPaymentData = payload;
        },

        softResetNewClientPayment: (state, {payload}) => {
            state.newClientPayment = {...state.newClientPaymentInitialValue, ...payload};
        },

        setEditClientPayment: (state, {payload}) => {
            state.editClientPayment = payload;
        },

        setClientPaymentsTemplates: (state, {payload}) => {
            state.clientPaymentsTemplates = payload;
        },

        resetEditClientEmronStockholder: (state) => {
            state.editClientEmronStockholder = newClientEmronStockholderInitialValue;
        },

        setClientEmronStockholders: (state, {payload}) => {
            state.clientEmron.stockholders = payload;
        },

        setClientPaymentsSearch: (state, {payload}) => {
            state.searchClientPayments = payload;
        },

        setTotalItemsCPS: (state, {payload}) => {
            state.totalItemsCPS = payload;
        },

        setperPageCPS: (state, {payload}) => {
            state.perPageCPS = payload;
        },

        setTotalItemsCMS: (state, {payload}) => {
            state.totalItemsCMS = payload;
        },

        setperPageCMS: (state, {payload}) => {
            state.perPageCMS = payload;
        },
        setTotalItemsCS: (state, {payload}) => {
            state.totalItemsCS = payload;
        },

        setperPageCS: (state, {payload}) => {
            state.perPageCS = payload;
        },

        // Report Primer Payments
        setPrimerPaymentsRequestData: (state, {payload}) => {
            state.reportPrimerPaymentsRequestData = payload;
        },
        setPrimerPaymentsResponseData: (state, {payload}) => {
            state.reportPrimerPaymentsResponseData = payload;
        },

        // Report Primer Payments Admin
        setPrimerPaymentsAdminRequestData: (state, {payload}) => {
            state.reportPrimerPaymentsAdminRequestData = payload;
        },
        setPrimerPaymentsAdminResponseData: (state, {payload}) => {
            state.reportPrimerPaymentsAdminResponseData = payload;
        },

        // Client Balance Report
        initClientBalanceReport: (state, {payload}) => {
            state.clientBalanceReportRequestData[payload.tabKey] = {...initClientBalanceReportRequestData};
            state.clientBalanceReportResponseData[payload.tabKey] = {...initClientBalanceReportResponseData};
        },
        setClientBalanceReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientBalanceReportRequestData[tabKey] = action.payload;
        },
        setClientBalanceReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientBalanceReportResponseData[tabKey] = action.payload;
        },

        // Client Movements Report
        initClientMovementsReport: (state, {payload}) => {
            state.clientMovementsReportRequestData[payload.tabKey] = {...initClientMovementsReportRequestData};
            state.clientMovementsReportResponseData[payload.tabKey] = {...initClientMovementsReportResponseData};
        },
        setClientMovementsReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientMovementsReportRequestData[tabKey] = action.payload;
        },
        setClientMovementsReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientMovementsReportResponseData[tabKey] = action.payload;
        },

        // Client Isozygio Report
        initClientIsozygioReport: (state, {payload}) => {
            state.clientIsozygioReportRequestData[payload.tabKey] = {...initClientIsozygioReportRequestData};
            state.clientIsozygioReportResponseData[payload.tabKey] = {...initClientIsozygioReportResponseData};
            state.clientIsozygioReportTotals[payload.tabKey] = {...initClientIsozygioReportTotals};
        },
        setClientIsozygioReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientIsozygioReportRequestData[tabKey] = action.payload;
        },
        setClientIsozygioReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientIsozygioReportResponseData[tabKey] = action.payload;
        },
        setClientIsozygioReportTotals: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientIsozygioReportTotals[tabKey] = action.payload;
        },

        // Client Contracts Report
        setClientContractsRequestData: (state, {payload}) => {
            state.clientContractsReportRequestData = payload;
        },
        setClientContractsResponseData: (state, {payload}) => {
            const existingTotals = state.clientContractsReportResponseData.totals;
            state.clientContractsReportResponseData = payload;
            state.clientContractsReportResponseData.totals = payload.totals || existingTotals;
        },

        // Emron Monthly Report
        setEmronMonthlyReportRequestData: (state, {payload}) => {
            state.emronMonthlyReportRequestData = payload;
        },
        setEmronMonthlyReportResponseData: (state, {payload}) => {
            state.emronMonthlyReportResponseData = payload;
        },

        // Emron Settlements Report
        setEmronSettlementsReportRequestData: (state, {payload}) => {
            state.emronSettlementsReportRequestData = payload;
        },
        setEmronSettlementsReportResponseData: (state, {payload}) => {
            state.emronSettlementsReportResponseData = payload;
        },
        setSelectedClientCategory: (state, {payload}) => {
            state.selectedClientCategory = payload;
        },

        // Primer POS Report
        setPrimerPosRequestData: (state, {payload}) => {
            state.primerPosRequestData = payload;
        },
        setPrimerPosResponseData: (state, {payload}) => {
            state.primerPosResponseData = payload;
        },
        setSelectedPrimerPos: (state, {payload}) => {
            state.selectedPrimerPos = payload;
        },

        // Primer POS List Report
        setPrimerPosListRequestData: (state, {payload}) => {
            state.primerPosListRequestData = payload;
        },
        setPrimerPosListResponseData: (state, {payload}) => {
            state.primerPosListResponseData = payload;
        },
        setSelectedPrimerPosList: (state, {payload}) => {
            state.selectedPrimerPosList = payload;
        },
        setInsertNewPrimerPosListData: (state, {payload}) => {
            state.insertNewPrimerPosListData = payload;
        },
        setPrimerPosPrintVoucherPosition: (state, {payload}) => {
            state.primerPosPrintVoucherPosition = payload;
        },

        setAiCommunicationHistory: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.aiCommunicationHistory[tabKey] = action.payload;
        },
        resetAiCommunicationHistory: (state, action) => {
            const tabKey = action?.meta?.tabKey;
            if (tabKey) {
                delete state.aiCommunicationHistory[tabKey];
            }
        },
    },
});

export const {
    setClients,
    setNewClient,
    setAutoNewClientFields,
    resetNewClient,
    setNewClientModal,
    resetNewClientModal,
    setSearchClients,
    setSearchClientMovements,
    setClientMovementsSearchByBalance,
    setSelectedEmronPaymentsFilters,
    setClientTemplates,
    setSelectedClientTemplate,
    setClientMovementsTemplates,
    setSelectedClientMovementsTemplate,
    setClientsSettings,
    setNewContactPoint,
    setEditContactPoint,
    setNewBankInfo,
    setEditBankInfo,
    resetNewBankInfo,
    resetEditBankInfo,
    setNewInstallations,
    resetNewInstallations,
    setNewNotes,
    resetNewNotes,
    setNewClientMovements,
    setNewCommunicationHistory,
    resetNewCommunicationHistory,
    setEditClientMovements,
    setEditClient,
    setClientsPayment,
    resetNewClientMovements,
    setNewClientPayment,
    setAutoClientPaymentData,
    resetNewClientPayment,
    setClientEmronStockholders,
    setClientPaymentsSearch,
    setTotalItemsCPS,
    setperPageCPS,
    setClientPaymentsTemplates,
    setEditClientPayment,
    resetEditClientEmronStockholder,
    setClientNewCategory,
    resetClientNewCategory,
    setTotalItemsCMS,
    setperPageCMS,
    setperPageCS,
    setTotalItemsCS,
    softResetNewClientPayment,

    setPrimerPaymentsRequestData,
    setPrimerPaymentsResponseData,

    setPrimerPaymentsAdminRequestData,
    setPrimerPaymentsAdminResponseData,

    // Client Balance Report
    initClientBalanceReport,
    setClientBalanceReportRequestData,
    setClientBalanceReportResponseData,

    // Client Movements Report
    initClientMovementsReport,
    setClientMovementsReportRequestData,
    setClientMovementsReportResponseData,

    // Client Isozygio Report
    initClientIsozygioReport,
    setClientIsozygioReportRequestData,
    setClientIsozygioReportResponseData,
    setClientIsozygioReportTotals,

    setClientContractsRequestData,
    setClientContractsResponseData,

    setEmronMonthlyReportRequestData,
    setEmronMonthlyReportResponseData,

    setEmronSettlementsReportRequestData,
    setEmronSettlementsReportResponseData,

    setPrimerPosRequestData,
    setPrimerPosResponseData,
    setSelectedPrimerPos,

    setPrimerPosListRequestData,
    setPrimerPosListResponseData,
    setSelectedPrimerPosList,
    setInsertNewPrimerPosListData,
    setPrimerPosPrintVoucherPosition,

    setSelectedClientCategory,

    setAiCommunicationHistory,
    resetAiCommunicationHistory,
} = ClientsSlice.actions;
